import * as betgalaxy from './NewMatchDetailsPage.styles.betgalaxy';
import * as betprofessor from './NewMatchDetailsPage.styles.betprofessor';
import * as betroyale from './NewMatchDetailsPage.styles.betroyale';
import * as fiestabet from './NewMatchDetailsPage.styles.fiestabet';
import * as goldenrush from './NewMatchDetailsPage.styles.goldenrush';
import * as juicybet from './NewMatchDetailsPage.styles.juicybet';
import * as puntcity from './NewMatchDetailsPage.styles.puntcity';
import * as puntgenie from './NewMatchDetailsPage.styles.puntgenie';
import * as questbet from './NewMatchDetailsPage.styles.questbet';
import * as sterlingparker from './NewMatchDetailsPage.styles.sterlingparker';
import * as vikingbet from './NewMatchDetailsPage.styles.vikingbet';
import * as volcanobet from './NewMatchDetailsPage.styles.volcanobet';
import * as wellbet from './NewMatchDetailsPage.styles.wellbet';
import * as forsport from './NewMatchDetailsPage.styles.forsport';
import * as junglebet from './NewMatchDetailsPage.styles.junglebet';
import * as sugarcastle from './NewMatchDetailsPage.styles.sugarcastle';
import * as oldgill from './NewMatchDetailsPage.styles.oldgill';
import * as buffalobet from './NewMatchDetailsPage.styles.buffalobet';
import * as titanbet from './NewMatchDetailsPage.styles.titanbet';
import * as gigabet from './NewMatchDetailsPage.styles.gigabet';
import * as slambet from './NewMatchDetailsPage.styles.slambet';
import * as betstride from './NewMatchDetailsPage.styles.betstride';
import * as templebet from './NewMatchDetailsPage.styles.templebet';
import * as goldenbet888 from './NewMatchDetailsPage.styles.goldenbet888';
import * as hyperbet from './NewMatchDetailsPage.styles.hyperbet';
import * as bet777 from './NewMatchDetailsPage.styles.bet777';
import * as chromabet from './NewMatchDetailsPage.styles.chromabet';
import * as bet575 from './NewMatchDetailsPage.styles.bet575';
import * as betblast from './NewMatchDetailsPage.styles.betblast';
import * as pyramidbet from './NewMatchDetailsPage.styles.pyramidbet';
import * as magnumbet from './NewMatchDetailsPage.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
